var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import ValidationTooltip from '../tooltip/validation-tooltip';
import { Color } from '../const/';
import { CheckboxInner } from './checkbox';
var CheckboxGroup = (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxGroup.prototype.render = function () {
        return (React.createElement(ValidationTooltip, { placement: this.props.toolTipPlacement || 'topLeft', visible: typeof this.props.invalidMessage === 'string' &&
                this.props.invalidMessage.length > 0, invalidMessage: this.props.invalidMessage, getTooltipContainer: this.props.getTooltipContainer },
            React.createElement(CheckboxWrap, { invalidMessage: this.props.invalidMessage }, this.props.children)));
    };
    return CheckboxGroup;
}(React.Component));
export default CheckboxGroup;
var CheckboxWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  label {\n    margin-right: 16px;\n  }\n\n  ", " {\n    &:before {\n      ", ";\n    }\n  }\n"], ["\n  label {\n    margin-right: 16px;\n  }\n\n  ", " {\n    &:before {\n      ",
    ";\n    }\n  }\n"])), CheckboxInner, function (_a) {
    var invalidMessage = _a.invalidMessage;
    return invalidMessage && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          border: 1px solid ", ";\n        "], ["\n          border: 1px solid ", ";\n        "])), Color.SOFT_RED);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=checkbox-group.js.map